import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const MedDoc: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29826)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.0527 1C20.0466 1 3.18254 1 3.18254 1C2.60373 1 2.04849 1.20664 1.63905 1.57514C1.23048 1.94364 1 2.44336 1 2.96429C1 7.875 1 22.6071 1 22.6071C1 22.824 1.19556 23 1.43651 23H17.521C17.7619 23 17.9575 22.824 17.9575 22.6071V6.05922H22.5478C22.7887 6.05922 22.9843 5.884 22.9843 5.66636V3.65414C22.9843 2.1935 21.673 1.00864 20.0527 1ZM17.9391 1.78571H3.18254C2.83508 1.78571 2.50246 1.90986 2.25714 2.13065C2.01095 2.35222 1.87302 2.65157 1.87302 2.96429V22.2143H17.0844V3.65414C17.0844 2.92578 17.4109 2.265 17.9391 1.78571ZM20.0335 1.78571H20.0352C21.1815 1.78571 22.1113 2.6225 22.1113 3.65414V5.2735H17.9575V3.65414C17.9575 2.6225 18.8872 1.78571 20.0335 1.78571Z'
          fill='url(#paint0_linear_12280_29826)'
          stroke='url(#paint1_linear_12280_29826)'
          strokeWidth='0.9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.45583 15.1838H13.4981C13.7394 15.1838 13.9344 15.0082 13.9344 14.7911C13.9344 14.574 13.7394 14.3984 13.4981 14.3984H5.45583C5.21456 14.3984 5.01953 14.574 5.01953 14.7911C5.01953 15.0082 5.21456 15.1838 5.45583 15.1838Z'
          fill='url(#paint2_linear_12280_29826)'
          stroke='url(#paint3_linear_12280_29826)'
          strokeWidth='0.9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.45583 17.8908H13.4981C13.7394 17.8908 13.9344 17.7153 13.9344 17.4981C13.9344 17.281 13.7394 17.1055 13.4981 17.1055H5.45583C5.21456 17.1055 5.01953 17.281 5.01953 17.4981C5.01953 17.7153 5.21456 17.8908 5.45583 17.8908Z'
          fill='url(#paint4_linear_12280_29826)'
          stroke='url(#paint5_linear_12280_29826)'
          strokeWidth='0.9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.91407 7.7461H5.57744C5.33675 7.7461 5.14062 7.92261 5.14062 8.13924V10.2787C5.14062 10.4954 5.33675 10.6719 5.57744 10.6719H7.91407V12.7748C7.91407 12.9915 8.11019 13.168 8.35089 13.168H10.7281C10.9688 13.168 11.1649 12.9915 11.1649 12.7748V10.6719H13.5016C13.7423 10.6719 13.9384 10.4954 13.9384 10.2787V8.13924C13.9384 7.92261 13.7423 7.7461 13.5016 7.7461H11.1649V5.64314C11.1649 5.42651 10.9688 5.25 10.7281 5.25H8.35089C8.11019 5.25 7.91407 5.42651 7.91407 5.64314V7.7461ZM8.35089 8.53237C8.59158 8.53237 8.7877 8.35586 8.7877 8.13924V6.03627H10.2913V8.13924C10.2913 8.35586 10.4874 8.53237 10.7281 8.53237H13.0647V9.88561H10.7281C10.4874 9.88561 10.2913 10.0621 10.2913 10.2787V12.3817H8.7877V10.2787C8.7877 10.0621 8.59158 9.88561 8.35089 9.88561H6.01426V8.53237H8.35089Z'
          fill='url(#paint6_linear_12280_29826)'
          stroke='url(#paint7_linear_12280_29826)'
          strokeWidth='0.9'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29826'
          x1='5.55244'
          y1='2.50015'
          x2='15.5823'
          y2='22.5885'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29826'
          x1='5.55244'
          y1='2.50015'
          x2='15.5823'
          y2='22.5885'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_29826'
          x1='6.8656'
          y1='14.452'
          x2='6.90489'
          y2='15.3461'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_29826'
          x1='6.8656'
          y1='14.452'
          x2='6.90489'
          y2='15.3461'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_29826'
          x1='6.8656'
          y1='17.159'
          x2='6.90489'
          y2='18.0531'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_29826'
          x1='6.8656'
          y1='17.159'
          x2='6.90489'
          y2='18.0531'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_29826'
          x1='6.96244'
          y1='5.78992'
          x2='10.3377'
          y2='13.3066'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_29826'
          x1='6.96244'
          y1='5.78992'
          x2='10.3377'
          y2='13.3066'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29826'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MedDoc;
